/**
 * Admin page — container that owns which view is active and swaps children.
 *
 * TODO(backend): route-level auth guard. Redirect to /login if no admin session.
 */

import { useEffect, useState } from "react";
import { AdminShell } from "../components/admin/AdminShell";
import { AdminOverview } from "../components/admin/AdminOverview";
import { AdminVerifications } from "../components/admin/AdminVerifications";
import { AdminEnrollment } from "../components/admin/AdminEnrollment";
import { AdminFlagged } from "../components/admin/AdminFlagged";
import { AdminCampaigns } from "../components/admin/AdminCampaigns";
import { AdminDonations } from "../components/admin/AdminDonations";
import { AdminUpdates } from "../components/admin/AdminUpdates";
import { AdminExtensions } from "../components/admin/AdminExtensions";
import { AdminUsers } from "../components/admin/AdminUsers";
import { AdminCuration } from "../components/admin/AdminCuration";
import { AdminReports } from "../components/admin/AdminReports";
import { AdminSettings } from "../components/admin/AdminSettings";
import { PENDING_VERIFICATIONS, ENROLLMENT_CHANGES } from "../data/adminMock";
import { getReports, subscribeReports } from "../lib/wallReports";
import { getReportedUpdates, subscribeUpdates } from "../lib/campaignUpdates";
import { getPendingExtensions, subscribeExtensions } from "../lib/campaignExtensions";
import { useNoIndex } from "../lib/useNoIndex";

const VIEWS = {
  overview:      AdminOverview,
  verifications: AdminVerifications,
  enrollment:    AdminEnrollment,
  flagged:       AdminFlagged,
  campaigns:     AdminCampaigns,
  donations:     AdminDonations,
  updates:       AdminUpdates,
  extensions:    AdminExtensions,
  users:         AdminUsers,
  curation:      AdminCuration,
  reports:       AdminReports,
  settings:      AdminSettings,
};

export default function Admin() {
  useNoIndex();
  const [active, setActive] = useState("overview");
  const [flaggedCount, setFlaggedCount] = useState(() =>
    Object.values(getReports()).filter((r) => !r.resolved).length,
  );
  const [updatesReportedCount, setUpdatesReportedCount] = useState(
    () => getReportedUpdates().length,
  );
  const [extensionsPendingCount, setExtensionsPendingCount] = useState(
    () => getPendingExtensions().length,
  );

  useEffect(
    () =>
      subscribeReports((store) =>
        setFlaggedCount(Object.values(store).filter((r) => !r.resolved).length),
      ),
    [],
  );

  useEffect(
    () => subscribeUpdates(() => setUpdatesReportedCount(getReportedUpdates().length)),
    [],
  );

  useEffect(
    () => subscribeExtensions(() => setExtensionsPendingCount(getPendingExtensions().length)),
    [],
  );

  const View = VIEWS[active] || AdminOverview;
  const pendingCount = PENDING_VERIFICATIONS.filter(
    (v) => v.status === "pending" || v.status === "in-review",
  ).length;
  const enrollmentCount = ENROLLMENT_CHANGES.filter((c) => c.reviewStatus === "pending").length;

  return (
    <AdminShell
      active={active}
      onNavigate={setActive}
      pendingCount={pendingCount}
      flaggedCount={flaggedCount}
      enrollmentCount={enrollmentCount}
      updatesReportedCount={updatesReportedCount}
      extensionsPendingCount={extensionsPendingCount}
    >
      <View onNavigate={setActive} />
    </AdminShell>
  );
}
